import * as React from 'react';

type EventType = any;

/**
 * The hook add handler when click outside of element
 * @param {any} ref
 * @param {void} handler
 * @return {void}
 */
export default function useClickOutside<T = any>(
    ref: any,
    handler: () => void,
) {
  /**
   * the function checks if a click was made on the Image Viewer
   * @param {EventType} e
   * @return {Boolean}
   */
  function checkOnImageViewerClick(e: EventType): Boolean {
    const isImageViewer = e.target.closest('.ReactModalPortal')
    return Boolean(isImageViewer)
  }

  /**
   * the function checks if the modal should be left open
   * @param {EventType} event
   * @return {Boolean}
   */
  function checkModalShouldStayOpened(event: EventType): Boolean {
    return !ref.current
    || ref.current.contains(event.target)
    || checkOnImageViewerClick(event)
  }

  React.useEffect(() => {
    const listener = (event: EventType) => {
      if (checkModalShouldStayOpened(event)) {
        return;
      }

      handler();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  },[ref, handler]);
}
